<div class="app-login-by-form">
  @if (backgroudImageUrl()) {
  <div class="background-image">
    <img
      [src]="backgroudImageUrl()"
      alt="background"
      class="w-full h-full object-cover"
    />
  </div>
  } @if (isAccountConfirmed()) {
  <div class="success-confirm" role="alert">
    <aprova-icon
      class="success-confirm__icon"
      name="check-circle-solid"
      size="32px"
      color="#10B981"
    />
    <div class="success-confirm__content">
      <span class="success-confirm__title">Conta confirmada com sucesso!</span>
      <small class="success-confirm__subtitle">
        Agora basta efetuar seu login abaixo.
      </small>
    </div>
  </div>
  }
  <div class="app-login-by-form__content">
    @if(sessionTimeout()){
    <div
      class="border rounded-lg border-red-500 px-2 py-3 flex space-x-1 mb-11"
    >
      <aprova-icon
        [name]="'exclamation-circle-outline'"
        size="20px"
        [color]="'#EF4444'"
      />
      <div class="text-red-500 text-sm font-normal">
        Sua sessão expirou. Realize o login novamente.
      </div>
    </div>
    } @if (data$ | async; as data) { @if (!data.loading) {
    <div class="login-panel">
      <div class="box-login">
        <span class="box-login__title">Acesse sua conta</span>

        @if (showAuthMethod(data.config, 'CREDENTIALS') && !hideSignUp()) {
        <span class="box-login__subtitle">
          É seu primeiro acesso?
          <a (click)="redirectToCreateAccount()">Crie sua conta</a>
        </span>
        } @if (showAuthMethod(data.config, 'CREDENTIALS') && subtitle()) {
        <span class="box-login__subtitle">{{ subtitle() }}</span>
        }
      </div>

      @if (showAuthMethod(data.config, 'CREDENTIALS')) {
      <form class="login-form" [formGroup]="form" (submit)="onSubmit()">
        <div class="login-form__fields">
          <aprova-input
            #inputEmail
            id="email"
            height="44px"
            inputClass="w-full px-[14px] py-[10px] text-base font-normal leading-[1.4] text-[#1C1C1C] focus:outline-none"
            labelClass="block text-sm font-medium leading-[1.4] text-[#1C1C1C]"
            [control]="form.controls.email"
            [label]="identifierConfig[identifierType].label"
            [placeholder]="identifierConfig[identifierType].placeholder"
            [mask]="identifierConfig[identifierType].mask"
            [required]="true"
            [errorMessages]="identifierConfig[identifierType].errorMessages"
            (input)="onFormInput()"
          />

          <aprova-input
            #inputPassword
            [inputType]="!showPassword() ? 'password' : 'text'"
            height="44px"
            inputClass="w-full px-[14px] py-[10px] text-base font-normal leading-[1.4] text-[#1C1C1C] focus:outline-none"
            labelClass="block text-sm font-medium leading-[1.4] text-[#1C1C1C]"
            [control]="form.controls.password"
            label="Senha"
            placeholder="Digite sua senha"
            [required]="true"
            [errorMessages]="{
              required: 'Ops! Senha precisa ser preenchida.',
              incorrect: identifierConfig[identifierType].errorMessages.incorrect
            }"
            (input)="onFormInput()"
          >
            <ng-container append>
              <aprova-icon
                [name]="!showPassword() ? 'eye-off-solid' : 'eye-solid'"
                size="16px"
                color="#656666"
                class="cursor-pointer"
                (click)="toggleInputPassword()"
              />
            </ng-container>
          </aprova-input>
        </div>

        <div class="login-form__actions">
          <label class="remember-me">
            <input
              type="checkbox"
              [checked]="rememberMe()"
              (change)="handleRemembermeChange()"
            />
            <span class="remember-me__checkmark"></span>
            <span class="remember-me__label">Lembrar de mim</span>
          </label>

          @if (!hideRecoverPassword()) {
          <button
            type="button"
            class="forgot-password"
            (click)="redirectToRecoverPassword()"
          >
            Esqueci minha senha
          </button>
          }
        </div>

        @if (!data.config.hideRecaptcha) {
        <aprova-recaptcha
          [recaptchaFormControl]="form.controls.recaptchaReactive"
          horizontalPosition="center"
          [errorMessages]="{
            required: 'Esta opção é obrigatória para prosseguir.'
          }"
        />
        @if (!form.controls['recaptchaReactive'].errors &&
        !form.controls['recaptchaReactive'].pristine) {
        <div></div>
        } }

        <aprova-button
          id="btn-login-submit"
          buttonType="submit"
          buttonClass="h-12 rounded-xl bg-[#12949C] px-4 text-base font-medium leading-[1.4] text-white hover:bg-[#0f848b]"
          [disabled]="logginIn()"
          [isLoading]="logginIn()"
          [label]="logginIn() ? 'Carregando' : 'Entrar'"
        />
      </form>
      }

      @if (hasAlternativeAuthMethods(data.config)) {
      <div class="alternative-logins">
        @if (showAuthMethod(data.config, 'GOOGLE')) {
        <div class="google-login-trigger">
          <div class="google-login-trigger__native">
            <aprova-google-button
              [width]="310"
              (signIn)="socialLogin($event)"
            ></aprova-google-button>
          </div>
          <div class="google-login-trigger__content" aria-hidden="true">
            <img src="/assets/images/google-logo.svg" alt="" />
            <span>Fazer login com o Google</span>
          </div>
        </div>
        }

        @if (showGovBrMethod(data.config) || showAuthMethod(data.config, 'ICP')) {
        <div class="alternative-logins-actions">
          @if (showAuthMethod(data.config, 'ICP')) {
          <button
            id="btn-login-icp"
            type="button"
            class="alternative-button alternative-button--compact"
            (click)="loginICP()"
          >
            <img src="/assets/images/icp-brasil.svg" alt="ICP Brasil" />
          </button>
          }

          @if (showGovBrMethod(data.config)) {
          <button
            id="btn-login-govbr"
            type="button"
            class="govbr-signin-button"
            (click)="loginGovBr(data.config)"
          >
            Entrar com&nbsp;<b>gov.br</b>
          </button>
          }
        </div>
        }

        <div
          class="single-login-instructions"
          [innerHTML]="showSingleLoginInstructions(data.config)"
        ></div>
      </div>
      } @else if(showIntegrationLoginButton(data.config)) {
      <div class="integration-login">
        <aprova-button
          id="btn-login-integration"
          buttonType="button"
          buttonClass="h-12 rounded-xl bg-[#12949C] px-4 text-base font-medium leading-[1.4] text-white hover:bg-[#0f848b]"
          class="w-full"
          [label]="loginButtonText(data.config)"
          (click)="redirectToIntegrationUrl(data.config)"
        />

        @if(showIntegrationLoginButton(data.config)) {
        <div class="external-login-url-label">
          Digite ou copie o endereço e abra em seu navegador:
        </div>

        <div class="integration-login__url-row">
          <div class="external-login-url">
            {{ integrationMethodUrl(data.config) }}
          </div>
          <div class="external-login-url-copy">
            @if (urlCopied()) {
            <aprova-icon name="check-solid" size="20px" color="#1AAF50" />
            } @else {
            <aprova-icon
              name="document-duplicate-outline"
              size="20px"
              color="#9ca3af"
              class="cursor-pointer"
              (click)="copyIntegrationMethodUrl(data.config)"
            />
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    } }
  </div>
</div>
